import { DashboardRouteNames } from '@/routes/constants/location'

import EmptyRouterParent from '../../pmd/pages/EmptyRouterParent.vue'
import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../auth'
const LocationDashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ '../../pmd/pages/reporting/dashboard/LocationDashboard.vue'
  ).then(m => m.default)

const LocationDashboardCreate = () =>
  import(
    /* webpackChunkName: "dashboard-create" */ '../../pmd/pages/reporting/dashboard/LocationDashboardCreate.vue'
  ).then(m => m.default)

export const DashboardRoute: RouteConfig[] = [
  {
    path: 'dashboard',
    name: DashboardRouteNames.default,
    component: LocationDashboard,
  },
  {
    path: 'dashboard/create',
    name: DashboardRouteNames.create,
    component: LocationDashboardCreate,
    beforeEnter: requireAuthAndLocation,
    meta: {
      hideTopBar: true,
      hideSideBar: true
    }
  },
  {
    path: 'dashboard/:dashboard_id',
    name: 'dashboard_navigate',
    component: LocationDashboard,
  }
]
